
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'orderServicerReport',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE_UNCOMPLETED;
  private stageSub = OrderServiceStage.SERVICE_STAGE_SUB_APPEAR;
private vt = ViewType.ORDER_SERVICER_REPORT;
}
